module.exports = __webpack_public_path__ + "static/icon_mc_securecode-706fc924d2a12a83508cd3bf33dcf0c2.svg";